import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';

import { CredentialVerification } from './../shared/models/products/credential-verification';
import { Exam } from './../shared/models/products/exam';
import { OtherProduct } from './../shared/models/products/other-product';
import { Renewal } from './../shared/models/products/renewal';
import { PurchaseStateService } from './../shared/services/purchase-state.service';

enum CheckoutTypes {
  Exam,
  ProductsRenewal
  //Products,
  //Renewal
}

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html'
})
export class CheckoutComponent implements OnInit {
  checkoutTypes = CheckoutTypes;
  checkoutType: CheckoutTypes;
  isCartEmpty: boolean = false;
  
  constructor(private purchaseState: PurchaseStateService,
              private router: Router,
              private route: ActivatedRoute) 
  { }

  ngOnInit() {  
    this.checkoutType = this.getCheckoutType();
    this.isCartEmpty = (this.checkoutType === null);
  }

  private getCheckoutType() {
    if (this.purchaseState.currentState.products.find(p => p.constructor === Exam))
      return CheckoutTypes.Exam;


    if (this.purchaseState.currentState.products.find(p => p.constructor === CredentialVerification || p.constructor === OtherProduct || p.constructor === Renewal))
      return CheckoutTypes.ProductsRenewal;

    //if (this.purchaseState.currentState.products.find(p => p.constructor === CredentialVerification || p.constructor === OtherProduct))
    //  return CheckoutTypes.Products;
    //
    //if (this.purchaseState.currentState.products.find(p => p.constructor === Renewal))
    //  return CheckoutTypes.Renewal;

    return null;
  }
}
